import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation('common');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="contact" className="py-10 md:py-20 bg-gray-50">
      <div className="container mx-auto px-3 md:px-6">
        <div className="text-center mb-6 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
            {t('contact.title')}
          </h2>
          <p className="text-xs md:text-lg text-gray-600">
            {t('contact.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-12">
          <div>
            <form onSubmit={handleSubmit} className="space-y-3 md:space-y-6">
              <div>
                <label htmlFor="name" className="block text-xs md:text-sm font-medium text-gray-700 mb-1 md:mb-2">
                  {t('contact.name')}
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-2 md:px-4 py-1.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-xs md:text-base"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-xs md:text-sm font-medium text-gray-700 mb-1 md:mb-2">
                  {t('contact.email')}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-2 md:px-4 py-1.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-xs md:text-base"
                  required
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-xs md:text-sm font-medium text-gray-700 mb-1 md:mb-2">
                  {t('contact.phone')}
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-2 md:px-4 py-1.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-xs md:text-base"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-xs md:text-sm font-medium text-gray-700 mb-1 md:mb-2">
                  {t('contact.message')}
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-2 md:px-4 py-1.5 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-xs md:text-base resize-none"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-teal-600 text-white py-2 md:py-3 rounded-lg hover:bg-teal-700 transition-colors text-xs md:text-base font-medium whitespace-nowrap cursor-pointer"
              >
                {t('contact.send')}
              </button>
            </form>
          </div>

          <div className="space-y-4 md:space-y-8">
            <div>
              <h3 className="text-base md:text-2xl font-bold text-gray-900 mb-3 md:mb-6">
                {t('contact.info')}
              </h3>
              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start gap-2 md:gap-4">
                  <div className="w-8 h-8 md:w-12 md:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-base md:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-xs md:text-base font-semibold text-gray-900 mb-0.5 md:mb-1">
                      {t('contact.address')}
                    </h4>
                    <p className="text-[9px] md:text-sm text-gray-600">
                      "Sahra" Building G.Kulyyev Street
                    </p>
                    <p className="text-[9px] md:text-sm text-gray-600">
                      Ashgabat, Turkmenistan
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-4">
                  <div className="w-8 h-8 md:w-12 md:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-base md:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-xs md:text-base font-semibold text-gray-900 mb-0.5 md:mb-1">
                      {t('contact.phone')}
                    </h4>
                    <p className="text-[9px] md:text-sm text-gray-600">
                      +993 65049474
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-4">
                  <div className="w-8 h-8 md:w-12 md:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-base md:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-xs md:text-base font-semibold text-gray-900 mb-0.5 md:mb-1">
                      {t('contact.email')}
                    </h4>
                    <p className="text-[9px] md:text-sm text-gray-600">
                      gbgrouptm@gmail.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-4">
                  <div className="w-8 h-8 md:w-12 md:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-base md:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-xs md:text-base font-semibold text-gray-900 mb-0.5 md:mb-1">
                      {t('contact.hours')}
                    </h4>
                    <p className="text-[9px] md:text-sm text-gray-600">
                      Every Day: 9:00 AM - 7:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}